const ENTITY_ROLE_TYPES = {
    VIEWER: 'VIEWER',
    OWNER: 'OWNER'
};

export default ENTITY_ROLE_TYPES;